import React, { useEffect } from "react";
import "./Who_We_Are.css";
import Common_Headings from "../../common_components/common_heading/Common_Headings";
import { AllAboutUs } from "../../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";

const Who_We_Are = () => {
  const dispatch = useDispatch();
  const all_about_us = useSelector((state) => state?.common?.all_about_us);
  console.log(all_about_us, "all_about_usall_about_usall_about_us");

  useEffect(() => {
    dispatch(AllAboutUs());
  }, [dispatch]);
  return (
    <section className="who-we-are container align-items-center justify-content-center">
      <div className="who-container">
        <div className="who-header">
          <Common_Headings title="WHO WE ARE" />

          <p className="who-description">
            We are a digital platform designed to make it easy for customers to
            connect directly with nearby material vendors & skilled service
            experts. Our goal is to simplify sourcing materials and hiring
            professionals by enabling quick, direct communication without
            intermediaries.
          </p>
        </div>

        <div className="who-body">
          <div className="who-stats">
            <div className="stat-card">
              <h3 className="stat-number">{all_about_us?.total_customer}</h3>
              <p className="stat-label">Customers Connected</p>
            </div>
            <div className="stat-card">
              <h3 className="stat-number">{all_about_us?.verify_vendor}</h3>
              <p className="stat-label">Verified Vendors</p>
            </div>
            <div className="stat-card">
              <h3 className="stat-number">{all_about_us?.total_expert}</h3>
              <p className="stat-label">Skilled Experts</p>
            </div>
            <div className="stat-card">
              <h3 className="stat-number">{all_about_us?.total}</h3>
              <p className="stat-label">Successful Connections</p>
            </div>
          </div>

          <div className="who-image-container">
            <img
              src="/assets/images/about-us-banner.png"
              alt="Team of experts"
              className="who-main-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Who_We_Are;
